import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraCombobox } from '@mono/ui-components';
import { useMemo } from 'react';
import { NAICS_CODES } from '../ProposalDashboard/v2/home/naicsCodes';
const OPTIONS = NAICS_CODES.map((n)=>({
        value: n.value,
        label: `${n.value} — ${n.description ?? ''}`.replace(/ — $/, ''),
        textValue: `${n.value} ${n.description ?? ''}`
    }));
/**
 * Searchable NAICS code picker (code or industry words). The list covers the common govcon
 * sectors, not every code, so a 6-digit code that is not listed can still be entered as typed.
 */ export function NaicsCodeCombobox({ label, value, onChange, disabled, testId }) {
    const options = useMemo(()=>{
        if (!value || OPTIONS.some((o)=>o.value === value)) return OPTIONS;
        return [
            {
                value,
                label: value,
                textValue: value
            },
            ...OPTIONS
        ];
    }, [
        value
    ]);
    return /*#__PURE__*/ _jsx(SpecraCombobox, {
        label: label,
        placeholder: "Search NAICS codes",
        searchPlaceholder: "Code or industry",
        emptyMessage: "No listed NAICS code matches.",
        options: options,
        value: value || undefined,
        onValueChange: (v)=>onChange(v ?? ''),
        clearable: true,
        disabled: disabled,
        onCreate: (q)=>onChange(q.trim()),
        canCreate: (q)=>/^\d{2,6}$/.test(q.trim()) && !OPTIONS.some((o)=>o.value === q.trim()),
        createLabel: (q)=>`Use NAICS ${q.trim()}`,
        triggerProps: testId ? {
            'data-testid': testId
        } : undefined
    });
}
